import { useCartStore } from '../../store/useCartStore';
import { useMemo } from 'react';
import { formatCurrency } from '../../constants/i18n';
import { deriveFreeShippingProgress } from '../../utils/cartCalculations';

// 这个 Hook 的作用：
// 1. 从 Store 取数据
// 2. 算免邮进度
// 3. 提供通用的交互动作 (比如打开购物车抽屉)

/**
 * 计算购物车汇总信息，并提供通用交互动作。
 * @returns 汇总数据与打开购物车的回调
 */
export function useCartSummary() {
  // 1. 从 Store 获取原始数据
  const count = useCartStore(s => s.count);
  const totalPriceCents = useCartStore(s => s.total_price);
  const currency = useCartStore(s => s.currency);
  const thresholdCents = useCartStore(s => s.freeShippingThreshold);
  const toggleCart = useCartStore(s => s.toggleCart);

  // 2. 衍生数据计算 (Derived State)
  const data = useMemo(() => {
    // 乐观计算：基础值 + pending 增量
    const optimisticCount = count;
    const optimisticTotalCents = totalPriceCents;

    const shippingProgress = deriveFreeShippingProgress(optimisticTotalCents, thresholdCents);

    return {
      count: optimisticCount,
      total: optimisticTotalCents,
      progress: shippingProgress.progress,        // 0 - 1 小数
      progressPercent: shippingProgress.progressPercent, // 0 - 100 整数
      isFreeShipping: shippingProgress.isFreeShipping,  // 是否免邮
      remaining: shippingProgress.remaining,       // 还差多少钱（cents）
      isEmpty: optimisticCount === 0,
      formattedTotal: formatCurrency(optimisticTotalCents, currency || 'EUR'),
    };
  }, [totalPriceCents, thresholdCents, count, currency]);

  // 3. 通用动作
  const handleOpenCart = () => {
    console.log("Open Cart Drawer / Page");
    // alert("打开购物车抽屉或跳转到购物车页面"); // 移除 alert，避免打断体验
    toggleCart(true); // 打开侧边栏状态
    // 或者 window.location.href = '/cart'; 
    // 跳转到购物车页面
  };

  return {
    // 原始数据 (暴露乐观值)
    // count: data.count, // 移除冗余
    // total: data.total, // 移除冗余
    currency,
    threshold: thresholdCents,

    // 计算后的数据
    ...data,

    // 动作
    handleOpenCart
  };
}
